module.exports = __webpack_public_path__ + "media/images/athletes/2461-45a45665d831bdb2824e5f7d6e46e205.png";